import Vue from 'vue'
import VueRouter from 'vue-router'
import AuthGuard from "./auth-guard";
import Calc from "../views/Calc.vue";
import Analise from "../views/analise.vue";
import Lista from "../views/Lista.vue";
import Config from "../views/Config.vue";
import Login from "../views/Login.vue";
import Cad from "../views/Cadastro.vue";
import NewUser from "../views/NovoUsuario.vue";
import Perfil from "../views/Perfil.vue";
import MyList from "../views/MyList.vue";
import GerarPdf from "../views/GeraPDF.vue";
import Envios from "../views/Envios.vue";
import PoliticaPrivacidade from "../assets/PoliticaPrivacidade.vue";
import TermosDeUso from "../assets/TermosDeUso.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/privacidade",
    name: "provacidade",
    component: PoliticaPrivacidade,
  },
  {
    path: "/termosdeuso",
    name: "termosdeuso",
    component: TermosDeUso,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/newuser",
    name: "new-user",
    component: NewUser,
  },
  {
    path: "/cadastro",
    name: "cadastro-complete",
    component: Cad,
    beforeEnter: AuthGuard,
  },
  {
    path: "/analise",
    name: "em-analise",
    component: Analise,
    beforeEnter: AuthGuard,
  },
  {
    path: "/perfil",
    name: "perfil-user",
    component: Perfil,
    beforeEnter: AuthGuard,
  },
  {
    path: "/",
    name: "calc-page",
    component: Calc,
    // beforeEnter: AuthGuard,
  },
  {
    path: "/admin",
    name: "admin-config",
    component: Config,
    beforeEnter: AuthGuard,
  },
  {
    path: "/my_list",
    name: "my-list",
    component: MyList,
    beforeEnter: AuthGuard,
  },
  {
    path: "/gerarpdf",
    name: "gerar-pdf",
    component: GerarPdf,
    beforeEnter: AuthGuard,
  },
  {
    path: "/lista",
    name: "admin-list",
    component: Lista,
    beforeEnter: AuthGuard,
  },
  {
    path: "/envios",
    name: "envio-fotos",
    component: Envios,
    beforeEnter: AuthGuard,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
